<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ "government_scores.pillars.title_single" | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" [formGroup]="entityPillarForm">
        <div class="row">
            <div class="col-sm-6 col-xs-12">
                <adaa-form-dropdown
                    controlName="pillarType"
                    formControlName="pillarType"
                    appendTo=".modal-content"
                    [label]="'government_scores.pillars.pillar_type' | translate"
                    [invalid]="submitted() && entityPillarForm.get('pillarType')?.invalid!"
                    [options]="pillarTypeOptions()"
                    [clearable]="true"
                    [required]="true"
                />
            </div>
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'common.tables.weight' | translate"
                    formControlName="weight"
                    controlName="weight"
                    [invalid]="submitted() && entityPillarForm.get('weight')?.invalid!"
                    [inputType]="'number'"
                    [required]="true"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <adaa-form-input
                    [label]="'executive_dashboard.title' | translate"
                    formControlName="summary"
                    controlName="summary"
                    [isTextArea]="true"
                />
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12 px-3">
                <adaa-data-table
                    #adaaDataTable
                    titleHeader="government_scores.pillars.area_of_focus.title"
                    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.GOV_ENTITY_PILLARS_AREA_OF_FOCUS_CONF"
                    [isLocalData]="true"
                    [localData]="focusList()"
                    [enableAdd]="pageMode() !== PageMode.view"
                    [enableViewAction]="pageMode() === PageMode.view"
                    [enableEditAction]="pageMode() !== PageMode.view"
                    [enableDeleteAction]="pageMode() !== PageMode.view"
                    (addNewClicked)="focus.focusIndex = null; focusIndex = null; focus.open()"
                    (actionClicked)="getAction($event)"
                />
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">
            {{ pageMode() === PageMode.view ? ("common.form.button.close" | translate) : ("common.form.button.cancel" | translate) }}
        </button>
        @if (pageMode() !== PageMode.view) {
            <button type="button" class="btn btn-primary" (click)="submit()">{{ "common.form.button.save" | translate }}</button>
        }
    </div>
</ng-template>

<adaa-area-of-focus-modal [focusList]="focusList()" [pageMode]="pageMode()" #focus (focus)="addFocusList($event)" />
